import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
  'data-ffid'?: string;
};

const Icon: React.FC<Props> = ({ className = '', dimension = 24, 'data-ffid': dataFfid }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={dimension}
    height={dimension}
    viewBox="0 0 512 512"
    fill="none"
    className={className}
    data-ffid={dataFfid}
  >
    <circle cx="256" cy="256" r="256" fill="currentColor" />
    <path
      d="M362.7 169.3c-8.4-8.4-22-8.4-30.4 0L224 277.6l-44.3-44.3c-8.4-8.4-22-8.4-30.4 0s-8.4 22 0 30.4l59.5 59.5c8.4 8.4 22 8.4 30.4 0l123.5-123.5c8.4-8.4 8.4-22 0-30.4z"
      fill="#fff"
    />
  </svg>
);

export default Icon;
